import clsx from "clsx";
import React from "react";

const SubHeading = ({ heading }) => {
  return (
    <div className={clsx("SubHeading", "text-center")}>
      <h2
        className={clsx(
          "SubHeading__heading",
          "inline-block text-center text-lg font-medium underline decoration-gray-500 decoration-1 underline-offset-4"
        )}
      >
        {heading}
      </h2>
    </div>
  );
};

export default SubHeading;
